import React from 'react'
// import Layout from '../components/Layout'
import Accordion from '../components/Accordian/Accordion'

// import './styles.css'

function Faq() {
  return (
    <div>
      <Accordion
        title="Why do I have to login with GitHub?"
        content="That's a great question! GitHub is a tool that anyone in the software industry eventually will need to use. You can create an account at github.com in just a couple clicks! The bonus is that you will never have to remember a username or password for this website 😂"
      />
      <Accordion
        title="Will I get a code review for a solution I submit?"
        content="While in Beta you can give feedback on your solution but we aren't at the point of allowing others to give feedback yet. Top of our our feature request list!"
      />
      <Accordion
        title="Can I use my solution in my portfolio?"
        content="Absolutely! Frontend Playground is meant to inspire you to create portfolio quality projects at your skill level."
      />
      <Accordion
        title="What if I get stuck?"
        content="Getting stuck is probably the most frustrating experience when learning to code. Especially, when learning alone. You now have the opportunity to see how others approached a problem and figured out a solution."
      />
      <Accordion
        title="What are the Figma design files?"
        content="Our site is loaded full of free changes that are great for testing and developing your skills. The Figma desings allow you to really approach your design with precision and mimics an actual workplace environment where you are implement a design. they will stretch you because you won't just throw content on the page and call it good. It will cause you to be precise and professional."
      />
      <Accordion
        title="Something isn't working"
        content="With the launch of this new site I'm anticipating that there are a number of bugs to be addressed and features that would be awesome to have! Please click the BETA banner in the upper left hand corner to submit feedback!"
      />
      <Accordion
        title="Contact"
        content="If you would like to reach out please feel free to click on the BETA banner in the upper left hand corner or mail us at: hey@frontendplayground.io"
      />
    </div>
  )
}

export default Faq
